import { Box, Card, Grid, Typography } from "@mui/material"

// --- NEW FUNCTION: To format date as "Started Date Month Year" ---
const formatStartedDate = (dateStr) => {
    if (!dateStr) return "";
    const d = new Date(dateStr);
    if (isNaN(d.getTime())) return "";
    const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    // return `${d.getDate()} ${months[d.getMonth()]} ${d.getFullYear()}`;
    return `${months[d.getMonth()]} ${d.getFullYear()}`;
};

const InfoBar = ({ title, subtitle, count, icon, onClick, isSuperAdmin = false, addedDate }) => {
    return (
        <Card className="info-bar" sx={{
            px: 1.5,
            py: 1.5,
            display: 'flex',
            gap: 2,
            alignItems: 'center',
            justifyContent: 'space-between',
            border: '1px solid #eeeeee45',
            borderRadius: 2, // Rounded corners matching Figma
            boxShadow: 'none' // Removed default shadow for a flat, clean look
        }}>

            {/* 1. Left Section: Icon, Title & Subtitle (Takes exactly 1/3rd space) */}
            <Box sx={{ flex: 1, display: 'flex', alignItems: 'center', gap: 2, justifyContent: 'flex-start' }}>
                {isSuperAdmin && (
                    <>
                        <Box className="info-icon-container light-border" sx={{ width: 64, minHeight: 48, display: 'flex', alignItems: 'center', justifyContent: 'center', borderRadius: 2 }}>
                            {icon}
                        </Box>
                        {/* <Box sx={{ borderRight: '2px solid #eee', height: '40px' }}></Box> */}
                    </>
                )}

            </Box>
            <Box width={1}>
                <Typography sx={{ textWrap: 'nowrap' }} className="dark-gray" fontSize={16} fontWeight={500}>{title}</Typography>
                <Typography className="light-gray" fontSize={14}>{subtitle}</Typography>
            </Box>

            {/* 2. Middle Section: Started Date (Perfectly Centered in 1/3rd space) */}
            <Box sx={{ flex: 1, display: { xs: 'none', sm: 'block' }, textAlign: 'center', alignItems: 'center' }}>
                <Box display={'flex'} alignItems={'center'}>
                    <Typography sx={{ textWrap: 'nowrap' }} className="light-gray" fontSize={14}>Start Date : </Typography>
                    <Typography sx={{ textWrap: 'nowrap' }} className="dark-gray" fontSize={14} fontWeight={500}>{addedDate}</Typography>
                </Box>
                <Box display={'flex'} alignItems={'center'} justifyContent={'space-between'}>
                    <Typography sx={{ textWrap: 'nowrap' }} className="light-gray" fontSize={14}>End Date : </Typography>
                    <Typography sx={{ textWrap: 'nowrap' }} className="dark-gray" fontSize={14} fontWeight={500}>{addedDate}</Typography>
                </Box>

            </Box>

            {/* 3. Right Section: Days Count & View Button (Takes exactly 1/3rd space, pushed to end) */}
            <Box sx={{ flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'flex-end', gap: 3 }}>
                <Box className="info-icon-container"
                    sx={{
                        textAlign: 'center', display: 'flex', flexDirection: 'column',
                        alignItems: 'center', width: 64, height: 48, justifyContent: 'center'
                    }}>
                    <Box className="rounded-lg input-label"
                        sx={{ px: 2, fontSize: 16, fontWeight: 600, color: Math.max(0, count) > 0 ? '#333' : 'inherit' }}>

                        {Math.max(0, count)}
                    </Box>
                    <Typography fontSize={13} sx={{ color: 'gray' }}>Days</Typography>
                </Box>

                <Typography className="dark-gray" sx={{ px: 1, fontSize: 15, fontWeight: 600, cursor: 'pointer' }} onClick={onClick}>
                    View
                </Typography>
            </Box>

        </Card>
    )
}

const InfoListCard = ({ datas = [], calc = (d) => { }, onClick = (data) => { }, isSuperAdmin = false }) => {
    return (<>
        <Box className="rounded-lg shadow light-border" sx={{ p: 2 }}>
            <Box sx={{ maxHeight: '700px', pr: 1, overflowY: 'auto' }}>
                <Grid container spacing={1.5} mb={2}>
                    {datas?.map((data, index) => {
                        // Extract date from data, fallback to created_at or start_project_date
                        const dateStr = data?.formatted_added_date || formatStartedDate(data?.created_at || data?.start_project_date);

                        return (
                            <Grid item size={{ xs: 12, md: 12 }} key={index}>
                                <InfoBar
                                    onClick={() => onClick(data)}
                                    title={data?.project_name}
                                    subtitle={data?.company_name}
                                    count={calc(data)}
                                    icon={data?.project_image && <img
                                        style={{ borderRadius: 5, objectFit: 'cover', boxShadow: 'none' }}
                                        src={data?.project_image} alt="" width={64} height={48}
                                        className="dark-gray"
                                        onError={(e) => { e.target.style.display = "none"; }} />}
                                    isSuperAdmin={isSuperAdmin}
                                    addedDate={dateStr} // Passed the formatted date here
                                />
                            </Grid>
                        )
                    })}
                </Grid>
            </Box>
        </Box>
    </>
    )
}

export default InfoListCard